import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './style/main.scss';
import { BrowserRouter } from 'react-router-dom';
import AppLaout from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <App Laout />
  </Provider>
);
